import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
//import Ipo from "./../../../Images/ipo.png";
import Ipo from "./../../../Images/home-products/ipo.png";
import "./IPOProduct.css";
import IpoFAQ from "./IpoFAQ/IpoFAQ";
import { useEffect } from "react";
import TrackApi from "../../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";
function IPOProduct() {
  let navigate = useNavigate();
  const routeChange = () => {
    let path = `/AllEquities`;
    navigate(path);
  };
  const [cookies, setCookie] = useCookies(['LeadId']);

  const trackData=(id)=>{
    const payloadData={
      "RelatedProspectId":id,
      "ActivityNote": "Your IPO Note",
      "mx_Custom_1": "IPO",
      "mx_Custom_2": "Your  IPO page Note",
      "mx_CustomObject_81":window.location.href
     }
     TrackApi(payloadData);
  }
  useEffect(()=>{
  
if(cookies && cookies.RelatedProspectId){
  trackData(cookies.RelatedProspectId);
}
    
  },[])
  return (
    <>
      {/* <div>IPO Product testing</div> */}
      <section className="welcome-equity">
        <Container>
          <Row>
            <Col lg={4} md={6} sm={12}>
              <div className="welcome-img-block">
                <img className="img-fluid" src={Ipo} alt="EquityImg" />
              </div>
            </Col>
            <Col lg={8} md={6} sm={12}>
              <div className="welcome-equity-beta">
                <h3>
                  <span>IPO</span>
                </h3>
                <p>
                  IPO is a public offering in which a private company (that has a handful of shareholders) is taken public by listing it on the stock exchange and offering its shares to investors in the primary market. A process used in IPO helps in efficient price discovery of the securities. The issuer provides a price band within which investors may bid, and the final price is determined by the issuer only after the bidding process has concluded. Prospective buyers are given information about the proposed offering in the form of a lengthy document known as a prospectus.
                </p>
                {/* <a onClick={routeChange}>
                  <span>Explore</span>
                </a>
                <button type="button">Sign Up</button> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="why-equity-block">
        <Container className="add-border">
          <Row>
            <Col lg={12} md={12} sm={12}>
              <div className="why-equitie-inn">
                <h3>
                  <span>Why IPO</span>
                </h3>
                <p>
                 The initial public offering (IPO) permits a large number of investors to buy the stock of a firm and contribute capital to the shareholders' equity. While going public, it may make the process simpler or less costly for a firm to get financing. One of the most significant benefits for a company is that it obtains access to a big pool of investors for capital raising. This facilitates easier acquisition deals, boosts public image, and can benefit sales and earnings, so benefiting end shareholders gradually.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <IpoFAQ />
    </>
  );
}
export default IPOProduct;
